const frameWidth = 630;
const frameHeight = 520;

export default {
  data: () => ({ copied: false }),
  methods: {
    shareCopy() {
      const val = this.$refs.copyElement.innerHTML.trim();
      this.$copy(val);
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 500);
    },

    shareFacebook(url) {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&facebook-share-dialog`, '_blank', `width=${frameWidth}, height=${frameHeight}, top=${(window.screen.height / 2) - (frameHeight / 2)}, left=${(window.screen.width / 2) - (frameWidth / 2)}`);
    },

    shareLinkedin(url) {
      window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${url}`, '_blank', `width=${frameWidth}, height=${frameHeight}, top=${(window.screen.height / 2) - (frameHeight / 2)}, left=${(window.screen.width / 2) - (frameWidth / 2)}`);
    },

    shareTwitter(url) {
      window.open(`https://twitter.com/intent/tweet?text=${url}`, '_blank', `width=${frameWidth}, height=${frameHeight}, top=${(window.screen.height / 2) - (frameHeight / 2)}, left=${(window.screen.width / 2) - (frameWidth / 2)}`);
    },
  },
};
